import { Type } from '@sinclair/typebox';
import { AtaPricingModel, AtaStatusType, AtaType } from '../../domain/ata/ata.js';
import { NullishType } from '../../standard-schema.js';
export var YesNo;
(function (YesNo) {
    YesNo["Yes"] = "yes";
    YesNo["No"] = "no";
})(YesNo || (YesNo = {}));
export const ListAtaParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const ListAtaSchema = Type.Object({
    id: Type.String(),
    serialNumber: NullishType(Type.Number()), // Löpnummer
    title: Type.String(), // Rubrik
    status: Type.Enum(AtaStatusType), // Status
    type: NullishType(Type.Enum(AtaType)), // Typ
    pricingModel: NullishType(Type.Enum(AtaPricingModel)), //Reglering
    priority: NullishType(Type.Number()), // Prio
    totalCost: NullishType(Type.Number()), // Kostnad
    sentDate: NullishType(Type.String()), // Skickad
    deadlineDate: NullishType(Type.String()), // Deadline
    answerReceivedDate: NullishType(Type.String()), // Svar erhållet
    revisionDate: NullishType(Type.String()), // Revisionsdatum
    invoiced: NullishType(Type.String()), // Fakturerad
});
export const GetAtaProjectQuerySchema = Type.Object({
    status: NullishType(Type.Enum(AtaStatusType)),
});
export const ListAtaResponseSchema = Type.Array(ListAtaSchema);
export const UpdateAtaListItemParamsSchema = Type.Object({
    id: Type.String(),
});
export const UpdateAtaListItemBodySchema = Type.Object({
    invoiced: NullishType(Type.String()),
});
export const AtaCostSchema = Type.Object({
    id: NullishType(Type.String()),
    accountNumber: Type.Number(), // Kostnadstyp
    description: NullishType(Type.String()), //Beskrivning
    numberOfItems: Type.Number(), //Antal
    unit: Type.String(), //Enhet
    pricePerUnit: Type.Number(), //Pris/Enhet
    markupFactor: NullishType(Type.Number()), //Påslag
    amount: Type.Number(), //Summa
});
export const GetAtaParamsSchema = Type.Object({
    id: Type.String(),
});
export const PutAtaParamsSchema = Type.Object({
    id: Type.String(),
});
const CommonAtaSchema = Type.Object({
    projectId: Type.String(),
    title: Type.String(), // Rubrik
    description: NullishType(Type.String()), // Beskrivning
    status: Type.Enum(AtaStatusType), // Status
    type: NullishType(Type.Enum(AtaType)), // Typ
    leadsToTimeExtension: NullishType(Type.Enum(YesNo)), // Äta medför tidsförlängning
    shouldBeRegulated: NullishType(Type.Enum(YesNo)), // Äta medför reglering
    shouldBeForecasted: NullishType(Type.Enum(YesNo)), // Om fast, prognostiseras
    pricingModel: NullishType(Type.Enum(AtaPricingModel)), //Reglering
    priority: NullishType(Type.Number()), // Prio
    sentDate: NullishType(Type.String()), // Skickad
    deadlineDate: NullishType(Type.String()), // Deadline
    answerReceivedDate: NullishType(Type.String()), // Svar erhållet
    revisionDate: NullishType(Type.String()),
    answer: NullishType(Type.String()), // Svar
    costs: Type.Array(AtaCostSchema),
});
export const GetAtaSchema = Type.Composite([
    Type.Object({
        id: Type.String(),
        serialNumber: NullishType(Type.Number()), // Löpnummer
        invoiced: NullishType(Type.String()), // Fakturera
    }),
    CommonAtaSchema,
]);
export const UpCreateAtaBodySchema = CommonAtaSchema;
// Params for the document routes — projectId first (matches the 'params.projectId' authorize selector)
export const AtaDocumentParamsSchema = Type.Object({
    projectId: Type.String(),
    ataId: Type.String(),
});
// POST response: metadata about the saved document (uploadedAt is an ISO string over the wire)
export const AtaDocumentMetadataSchema = Type.Object({
    filename: Type.String(),
    sizeBytes: Type.Number(),
    uploadedAt: Type.String(),
});
export const GetAtasWithCostResponseSchema = Type.Array(Type.Object({
    id: Type.String(),
    projectId: Type.String(),
    serialNumber: NullishType(Type.Number()), // Löpnummer
    title: Type.String(), // Rubrik
    description: NullishType(Type.String()), // Beskrivning
    status: NullishType(Type.String()), // Status
    type: NullishType(Type.String()), // Typ
    leadsToTimeExtension: NullishType(Type.String()), // Äta medför tidsförlängning
    shouldBeRegulated: NullishType(Type.String()), // Äta medför reglering
    shouldBeForecasted: NullishType(Type.String()), // Om fast, prognostiseras
    pricingModel: NullishType(Type.String()), //Reglering
    priority: NullishType(Type.Number()), // Prio
    sentDate: NullishType(Type.String()), // Skickad
    deadlineDate: NullishType(Type.String()), // Deadline
    answerReceivedDate: NullishType(Type.String()), // Svar erhållet
    revisionDate: NullishType(Type.String()),
    answer: NullishType(Type.String()), // Svar
    totalCost: NullishType(Type.Number()), // Total kostnad
}));
